module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-alert', {
    attrs: {
      "type": "warning",
      "show-icon": "",
      "title": "Under Development",
      "description": "Please review and comment.",
      "closable": false
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "padded"
  }, [_c('el-col', {
    attrs: {
      "align": "left"
    }
  }, [(!_vm.hidePanel) ? _c('edit-pane', {
    ref: "ep",
    attrs: {
      "prefix": "Payment: ",
      "title": _vm.form.summary,
      "is-edit": _vm.editMode
    },
    on: {
      "save": _vm.onSave,
      "cancel": _vm.onCancel,
      "edit": _vm.onEdit,
      "add": _vm.onSave
    }
  }) : _vm._e(), _vm._v(" "), _c('el-form', {
    attrs: {
      "model": _vm.localData,
      "label-width": "120px"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 11
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Sharer",
      "required": ""
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Enter Sharer (min 2 letters)",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.organisation_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "organisation_id", $$v)
      },
      expression: "form.organisation_id"
    }
  }, _vm._l((this.sharers), function(org) {
    return _c('el-option', {
      key: org.organisation.name,
      attrs: {
        "label": org.organisation.name,
        "value": org.id
      }
    }, [_c('span', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._v(_vm._s(org.organisation.name))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right",
        "color": "#8492a6",
        "font-size": "13px"
      }
    }, [_vm._v(_vm._s(org.telcoSiteId))])])
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Invoice",
      "required": ""
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Search Invoice No",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.form.invoice_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "invoice_id", $$v)
      },
      expression: "form.invoice_id"
    }
  }, _vm._l((this.utility), function(util) {
    return _c('el-option', {
      key: util.id,
      attrs: {
        "label": util.invoiceNo,
        "value": util.id
      }
    }, [_c('span', {
      staticStyle: {
        "float": "left"
      }
    }, [_vm._v(_vm._s(util.invoiceNo))]), _vm._v(" "), _c('span', {
      staticStyle: {
        "float": "right",
        "color": "#8492a6",
        "font-size": "13px"
      }
    }, [_vm._v(_vm._s(util.total))])])
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('table', {
    staticClass: "el-table"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Amount")]), _vm._v(" "), (_vm.showTax()) ? _c('th', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v(_vm._s(_vm.taxLabel) + " " + _vm._s(_vm.rowData.taxRate) + "%")]) : _vm._e()])]), _vm._v(" "), _c('tfoot', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Non-Refundable "), _c('i', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("per sharer")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Admin Charges")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm.formatNumber(_vm.form.adminCharges)))]), _vm._v(" "), (_vm.showTax()) ? _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm.formatNumber(_vm.adminTax)))]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('th', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Refundable "), _c('i', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("per sharer")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(_vm._s(_vm.utilLabel) + " Advance")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm.formatNumber(_vm.form.advanceCharges)))]), _vm._v(" "), (_vm.showTax()) ? _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm.formatNumber(_vm.advanceTax)))]) : _vm._e()])])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('date-input', {
    attrs: {
      "label": "Date Paid",
      "placeholder": "Paid Date",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.localData.paidDate),
      callback: function($$v) {
        _vm.$set(_vm.localData, "paidDate", $$v)
      },
      expression: "localData.paidDate"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Reference No."
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Paid Ref",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.localData.paidRef),
      callback: function($$v) {
        _vm.$set(_vm.localData, "paidRef", $$v)
      },
      expression: "localData.paidRef"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Paid Amount"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.localData.amountPaid),
      callback: function($$v) {
        _vm.$set(_vm.localData, "amountPaid", $$v)
      },
      expression: "localData.amountPaid"
    }
  })], 1)], 1), _vm._v(" "), (_vm.showTax()) ? _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tax Paid"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "number",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.localData.taxPaid),
      callback: function($$v) {
        _vm.$set(_vm.localData, "taxPaid", $$v)
      },
      expression: "localData.taxPaid"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12,
      "offset": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Total Paid"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.totalPaid))])])], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-28f8db4e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/utility/UtilityLicenseePayment.vue
// module id = 1385
// module chunks = 0